import I18n from 'I18n';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIEmptyState from 'UIComponents/empty/UIEmptyState';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { jsx as _jsx } from "react/jsx-runtime";
const NoResultsIllustration = () => /*#__PURE__*/_jsx(UIIllustration, {
  name: "empty-state-charts",
  className: "m-bottom-2",
  alt: I18n.text('noResultsMessage')
});
const PrimaryContent = () => /*#__PURE__*/_jsx("div", {
  children: /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.state.emptyState.noFormsInFolderExplanation"
    })
  })
});
const EmptyStateFolder = () => /*#__PURE__*/_jsx(NavMarker, {
  name: "FORMS_DASHBOARD_NO_RESULTS",
  children: /*#__PURE__*/_jsx(UIEmptyState, {
    id: "forms-dashboard-no-results",
    "data-test-id": "forms-dashboard-no-results",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.state.emptyState.noFormsInFolder"
    }),
    primaryContent: /*#__PURE__*/_jsx(PrimaryContent, {}),
    secondaryContent: /*#__PURE__*/_jsx(NoResultsIllustration, {}),
    secondaryContentWidth: 200
  })
});
export default EmptyStateFolder;